import View from 'app/views/view';

export default class GalleryAssetView extends View {
  constructor(model, gallery) {
    super(model);
    this.gallery = gallery;
  }

  isDownloadable() {
    return (
      !this.isAnalogArchive &&
      ((this.agreement && !this.gallery.isExhausted()) ||
        this.gallery.isViewOnly())
    );
  }

  isPurchasable() {
    return (
      !this.isOffline &&
      !this.isAnalogArchive &&
      this.agreements.indexOf('PA') < 0 &&
      this.agreements.indexOf('ED') < 0
    );
  }

  agreementPrefix() {
    for (const name of ['ED', 'PA', 'RF', 'IP', 'premium_pack', 'EA']) {
      if (this.agreements.indexOf(name) > -1) {
        return name;
      }
    }
    return null;
  }

  isExclusive() {
    return (
      this.editorialOnly &&
      this.assetType === 'image' &&
      !this.gallery.isEditorialImageOnly
    );
  }

  isFilmOrVideoTemplate() {
    return this.assetType === 'film' || this.assetType === 'videotemplate';
  }

  isVertical() {
    return this.orientation === 'Vertical';
  }

  isHorizontal() {
    return this.orientation === 'Horizontal';
  }

  isPanoramicHorizontal() {
    return this.orientation === 'PanoramicHorizontal';
  }

  mosaicImageDimensions() {
    const maxImageWidth = this.maxDimensions ? this.maxDimensions.width : 0;
    const maxImageHeight = this.maxDimensions ? this.maxDimensions.height : 0;

    const desiredSize = this.assetType === 'film' ? 640 : 612;

    const ratio = Math.min(
      desiredSize / maxImageWidth,
      desiredSize / maxImageHeight
    );
    return {
      width: Math.floor(maxImageWidth * ratio),
      height: Math.floor(maxImageHeight * ratio),
    };
  }

  mosaicBackgroundColor() {
    return this.colorIndexes?.length > 0 && this.assetType === 'image'
      ? `#${this.colorIndexes[0]}`
      : '';
  }

  gatewayCssClasses(offlineContentOnly = false) {
    const gatewayAssetClasses = ['gallery-gateway-asset'];
    if (this.assetType === 'film') {
      gatewayAssetClasses.push('gallery-gateway-video');
    }

    if (offlineContentOnly) {
      gatewayAssetClasses.push('gallery-gateway-offlinecontent');
    }

    if (this.orientation === 'PanoramicHorizontal') {
      gatewayAssetClasses.push('gallery-gateway-pano-horiz');
    }
    return gatewayAssetClasses;
  }
}
